import React from 'react';
import { Helmet } from 'react-helmet';

import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
import Section5 from './section5';
import Section6 from './section6';
import Section7 from './section7';

import './main.css';

function Australia_council() {
    return (
        <>
            <Helmet>
                <title>Australia Council</title>
            </Helmet>
            <div>
                <Section1 />
                <Section2 />
                <Section3
                    info1Num="01"
                    info1="Transforming a century-old paper-based
                     process into a Digital-centered system with
                     maximum efficiency and minimal confusion"
                    info2Num="02"
                    info2="Implementing a solution (e.g. WorkDay,
                        ServiceNow, SAP) that is easily navigable,
                        usable and adoptable for both your constituents and employees "/>
                <Section3
                    info1Num="03"
                    info1="Adopting and integrating an accurate method to
                    properly track the ROI of each software investment"
                    info2Num="04"
                    info2="Researching and identifying efficient and reliable training/onboarding solutions that
                    can replace previous systems that were undertaken face-to-face" />
                <Section5 />
                <Section6 />
                <Section7 />
            </div>

        </>
    );
}

export default Australia_council;
